import { render, staticRenderFns } from "./filter_booleanColumn.vue?vue&type=template&id=4c07d220&scoped=true&"
import script from "./filter_booleanColumn.vue?vue&type=script&lang=js&"
export * from "./filter_booleanColumn.vue?vue&type=script&lang=js&"
import style0 from "./filter_booleanColumn.vue?vue&type=style&index=0&id=4c07d220&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c07d220",
  null
  
)

export default component.exports